"use client";
import {
  createDisclosureStore
} from "./6E4KKOSB.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
